import API from '../../common/http/api.fetch';
import {success, responseMessage} from '../../common/utils/util.notifier';
import {dashboardState} from './accreditation.states';
import {GRID_FETCH} from '../../common/grid/grid.constants';
import I18N from '../../common/utils/util.i18n';
import {IDS} from "./accreditation-action-id.constants";
import {TYPES} from "./accreditation-action-type.constants";
import * as GRID from "../../common/grid/grid.constants";
import pick from "lodash/pick";

export const addRegulatoryFramework = (data, getConfigs, $state) => {
    return dispatch => {
        return API.fetch({
            url:    '/rco/add-regulatory-framework',
            method: 'POST',
            data:   {
                ...data,
                for_assessment_only: 1,
            },
        }).then(response => {
            dispatch(getConfigs()).then(() => {
                $state.go(dashboardState.name);
            });
            success('ACCREDITATION.NOTIFICATIONS.SCHEME.ADD')
        }, error => {
            responseMessage(error);
        })
    }
}


/* APP HEADER - acc-location-search.component */

export const getRegulatoryFrameworkDetails = (code) => {
    return dispatch => {
        return API.fetch({
            url:    '/rco/get-regulatory-framework-details',
            method: 'GET',
            params: { code }
        }).then(({data}) => {
            return data[0]
        }, error => {
            responseMessage(error);
        });
    };
}

export const fetchFrameworkRequirementsTreeProgress = (scheme_code, slo_uuid, fiscal_year) => {
    return dispatch => {
        return API.fetch({
            url: '/rco/framework-requirements-tree-progress',
            params: {slo_uuid, fiscal_year, scheme_code},
            method: 'GET'
        }).then( response => {
            const sectionsList = index(response.data);
            sectionsList.forEach(item => {
                item.statusName = I18N.translate(
                    `ACCREDITATION.EVIDENCE.STATUS.${item.requirement_page_status.toUpperCase()}`
                );
            })
            dispatch({
                type: TYPES.FETCH_SECTIONS_TREE_PROGRESS,
                data: response.data
            });
            return response.data;
        }, error => {
            responseMessage(error);
        });
    }
}

export const generateDocument = (data) => {
    return dispatch => {
        return API.fetch({
            url: '/accreditation/generate-document',
            method: 'POST',
            data
        }).then(response => {
            return response.data;
        },error => {
            responseMessage(error)
        });
    };
};

export const selectRequirementById = (id) => {
    return dispatch => {
        return dispatch({
            type: TYPES.SELECT_REQUIREMENT,
            requirementId: parseInt(id),
        });
    }
}

export const addEvidenceOwner = (data) => {
    return dispatch => {
        return API.fetch({
            url: `/rco/add-evidence-owner`,
            method: 'POST',
            data,
        }).then(response => {
            success('COMMON.SERVER_RESPONSE.ITEM_UPDATED');
        },error => {
            responseMessage(error)
        });
    };
};
export const fetchFrameworkRequirementsTree = (scheme_code, slo_uuid = null, fiscal_year = null, skip_empty_nodes = false) => {
    return dispatch => {
        return API.fetch({
            url:    '/rco/framework-requirements-tree',
            method: 'GET',
            params: {
                scheme_code,
                ...(slo_uuid ? {slo_uuid} : {}),
                ...(fiscal_year ? {fiscal_year} : {}),
                ...(skip_empty_nodes ? {skip_empty_nodes: 1} : {}),
            }
        }).then(response => {
            dispatch({
                type:   TYPES.FETCH_REQUIREMENTS_TREE,
                data:   response.data
            })
        }, error => {
            responseMessage(error);
        });
    };
}

const index = (children, list = []) => {
    children && children.forEach(item => {
        if(item) {
            list[parseInt(item.id)] = item;
            index(item.children, list);
        }
    })
    return list;
};

export const fetchEmployeesAndManagers = (keyword, location, path) => {
    if (!location) {
        return () => {};
    }
    return (dispatch) => {
        return API.fetch({
            url: `/employees-and-managers`,
            method: 'GET',
            params: {
                keyword,
                status: 'act',
                licences: false,
                offset: 0,
                limit: 20,
                location,
            }
        }).then(response => {
            dispatch({
                type: TYPES.FETCH_AUTOCO_EMPLOYEES_AND_MANAGERS,
                data: response.data.list.map(item => ({
                    ...item,
                    name: `${item.first_name} ${item.last_name}`,
                    // sub_uuid: item.sub_uuid,
                    // type: item.type,
                    // email: item.email,
                    // username: item.username,
                })),
                path,
            })
        });
    }
};

export const fetchAutocompleteUser = (uuid, autocompletePath, detailsPath) => {
    return (dispatch) => {
        return API.fetch({
            url: `/employee-details`,
            method: 'GET',
            params: {
                emp_uuid: uuid,
            }
        }).then(response => {
            const user = response.data[0][0];
            dispatch({
                type: TYPES.FETCH_AUTOCOMPLETE_USER_DETAILS,
                data: {
                    ...user,
                    subject_uuid: uuid,
                    name: `${user.first_name} ${user.last_name}`,
                },
                autocompletePath,
                detailsPath,
            })
        });
    }
};

export const addDocumentVersion = (data) => {
    return dispatch => {
        return API.fetch({
            url: `/rco/add-document-version`,
            method: 'POST',
            data,
        }).then(response => {
            success('COMMON.SERVER_RESPONSE.ITEM_UPDATED');
            return response.data;
        },error => {
            responseMessage(error)
        });
    };
}

export const removeDocumentFromEvidenceGroup = (data) => {
    return dispatch => {
        return API.fetch({
            url: `/rco/remove-document-from-evidence-group`,
            method: 'PUT',
            data,
        }).then(response => {
            success('COMMON.SERVER_RESPONSE.ITEM_DELETED');
            return response.data;
        },error => {
            responseMessage(error)
        });
    };
}